(function ($) {
    
//    const wait = (delay = 0) => new Promise(resolve => setTimeout(resolve, delay));
//
//    const setVisible = (elementOrSelector, visible) => (typeof elementOrSelector === 'string' ? document.querySelector(elementOrSelector) : elementOrSelector).style.display = visible ? 'flex' : 'none';
//
//    setVisible('#preloader', true);
//
//    document.addEventListener('DOMContentLoaded', () => wait(1000).then(() => {
//        setVisible('#preloader', false);
//    }));
    

	/* Document Ready */
	$(document).ready(function() {
        $(".preload").fadeOut("fast");
       
	});

    // Wait for window load
//	$(window).load(function() {
//		$(".preload").fadeOut("fast");
//	});


})(jQuery);